import { makeStyles } from '@material-ui/core';

const styles = makeStyles((theme) => ({
    name: {
        fontWeight: '500',
        paddingLeft: '7px',
        // whiteSpace: 'noWrap',
        textAlign: 'start',
        [theme.breakpoints.down(1025)]: {
            paddingLeft: '0px'
        }
    },
    patientRow: {
        display: 'grid',
        gridTemplateColumns: '3fr 2fr 1fr 2fr 2fr 3fr',
        alignItems: 'center',
        gridGap: '10px',
        borderRadius: '8px',
        '&:nth-of-type(odd)': {
            background: '#e8ecf2'
        },
        '&:hover': {
            cursor: 'pointer',
            backgroundColor: '#d4e4fc !important'
        },
        '& > div ': {
            padding: '16px 0',
            width: '100%',
            // maxWidth: '300px',
            // minWidth: '220px',
            textAlign: 'start'
        },
        '& > div:nth-child(1) ': {
            paddingInlineStart: '24px'
        },
        // '& > div:nth-child(3) ': {
        //     minWidth: '120px'
        // },
        // [theme.breakpoints.up(1265)]: {
        //     '& > div ': {
        //         minWidth: '250px'
        //     }
        // },
        [theme.breakpoints.down(1025)]: {
            // gridTemplateColumns: '165px 150px 130px 150px 150px 200px',
            '&:nth-of-type(odd)': {
                background: '#fff'
            },
            '& > div': {
                textAlign: 'center'
            },
            '& > div:nth-child(1) ': {
                paddingInlineStart: '0px'
            }
        }
        //     '& > div ': {
        //         minWidth: '165px',
        //         padding: '20px 0px 20px 0px'
        //     },
        //     '& > div:nth-child(3) ': {
        //         minWidth: '130px'
        //         // textAlign: 'center'
        //     },
        //     '& > div:nth-child(5) ': {
        //         minWidth: '155px'
        //     }
        // '&:hover': {
        //     cursor: 'pointer',
        //     backgroundColor: '#d4e4fc'
        // }
        // }
    },
    NID: {
        width: '115px',
        textAlign: 'left'
    },
    age: {
        width: '100px',
        '& *': {
            wordSpacing: '.2em'
        }
    },
    overall: {
        // width: '255px',
        display: 'flex',
        alignItems: 'center',
        '& svg:first-child': {
            marginTop: '2px',
            marginInlineStart: (props) => (props.rtl ? '8px' : 'unset'),
            marginInlineEnd: (props) => (!props.rtl ? '8px' : 'unset'),
            transform: (props) =>
                props.hasActiveLinks
                    ? 'rotate(-88deg) translateX(3px)'
                    : props.rtl
                    ? 'rotate(0deg)'
                    : 'rotate(-180deg)',
            width: '16px',
            height: '16px',
            color: (props) => (props.hasActiveLinks ? '#416ce1' : '#b0b0b0')
        },
        '& img': {
            marginInlineEnd: '5px'
        }
    },
    lastVisitDate: {
        width: '150px'
    },
    lastVisitTime: {
        width: '223px',
        '& span': {
            minWidth: '33px',
            display: 'inline-block',
            '&:first-child': {
                paddingLeft: '15px',
                minWidth: '70px'
            },
            '&:last-child': {
                textAlign: 'center'
            }
        }
    },
    acordinWrapper: (props) => ({
        marginTop: '16px',
        position: 'sticky',
        right: props.rtl ? '13px' : 'unset',
        left: props.rtl ? 'unset' : '13px',
        zIndex: '1',
        [theme.breakpoints.down(768)]: {
            maxWidth: '90vw'
        }
    }),
    acordinRow: {
        padding: '12px 24px',
        borderRadius: '6px',
        backgroundColor: '#f5f6fa',
        display: 'flex',
        justifyContent: 'space-between',
        marginBottom: '8px',
        '&:hover': {
            backgroundColor: '#d4e4fc',
            cursor: 'pointer'
        }
    },
    acordinLink: {
        fontFamily: 'inherit',
        fontSize: '14px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: '1.07',
        letterSpacing: 'normal',
        textAlign: 'right',
        color: '#416ce1'
    },
    arrowIconAcordin: {
        width: '16px',
        height: '16px',
        color: '#416ce1',
        transform: (props) => (props.rtl ? 'rotate(0deg)' : 'rotate(-180deg)'),
        zIndex: 10
    },
    tagsContainer: {
        display: 'flex',
        alignItems: 'center',
        flexFlow: 'wrap',
        [theme.breakpoints.down(1025)]: {
            marginInlineStart: '23px'
        },
        [theme.breakpoints.down(883)]: {
            margin: 0
        }
    },
    tag: {
        marginInlineEnd: '6px',
        margin: '4px 0',
        borderRadius: '6px',
        background: '#f2f4f7',
        fontSize: '12px',
        padding: '4px 8px'
    },
    dash: {
        [theme.breakpoints.up(1024)]: {
            paddingInlineStart: '20px'
        }
    }
}));

export { styles };
